/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a 20-minute nap better than a 30-minute nap?`)
};

const es_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es mejor una siesta de 20 minutos que una de 30?`)
};

const de_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist ein 20-Minuten-Nap besser als ein 30-Minuten-Nap?`)
};

const nl_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een dutje van 20 minuten beter dan een dutje van 30 minuten?`)
};

const fr_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une sieste de 20 minutes est-elle meilleure qu’une sieste de 30 minutes ?`)
};

const it_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un pisolino di 20 minuti è meglio di uno di 30 minuti?`)
};

const pt_br2_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um cochilo de 20 minutos é melhor do que um de 30 minutos?`)
};

const pt_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma soneca de 20 minutos é melhor do que uma de 30 minutos?`)
};

const ja_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20分の仮眠は30分の仮眠より良いのですか？`)
};

const zh_timer_u20m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20分钟小睡比30分钟小睡更好吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u20m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u20m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u20m_faq4_q", locale)
	if (locale === "en") return en_timer_u20m_faq4_q(inputs)
	if (locale === "es") return es_timer_u20m_faq4_q(inputs)
	if (locale === "de") return de_timer_u20m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u20m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u20m_faq4_q(inputs)
	if (locale === "it") return it_timer_u20m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u20m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u20m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u20m_faq4_q(inputs)
	return zh_timer_u20m_faq4_q(inputs)
};